import React from 'react'
import Pt from 'prop-types'
import { Button, FormControl, InputGroup } from 'react-bootstrap'

import Icon from '../Icon'

export default class LockingPasswordField extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      passwordRevealed: false,
    }
  }

  toggleRevealed = () => {
    this.setState({
      passwordRevealed: !this.state.passwordRevealed,
    })
  }

  render() {
    const {
      bsSize,
      hasPassword = false,
      hasPasswordValue,
      setPassword,
      showRevealPassword = false,
      value,
      ...other
    } = this.props

    if (hasPassword) {
      return (
        <InputGroup bsSize={bsSize}>
          <FormControl {...other} type="text" disabled value={hasPasswordValue} />
          <InputGroup.Button>
            <Button onClick={() => setPassword('')}>
              Change Password
            </Button>
          </InputGroup.Button>
        </InputGroup>
      )
    }

    const passwordControl = (
      <FormControl
        {...other}
        onChange={e => setPassword(e.target.value)}
        type={this.state.passwordRevealed ? 'text' : 'password'}
        value={value}
      />
    )

    if (!showRevealPassword) {
      return passwordControl
    }

    return (
      <InputGroup bsSize={bsSize}>
        {passwordControl}
        <InputGroup.Button>
          <Button onClick={this.toggleRevealed}>
            <Icon name="search" />{' '}
            {this.state.passwordRevealed ? 'Hide' : 'Reveal'} Password
          </Button>
        </InputGroup.Button>
      </InputGroup>
    )
  }
}

LockingPasswordField.defaultProps = {
  hasPasswordValue: 'Password Set',
}

LockingPasswordField.propTypes = {
  bsSize: Pt.string,
  hasPassword: Pt.bool,
  hasPasswordValue: Pt.string,
  setPassword: Pt.func.isRequired,
  showRevealPassword: Pt.bool,
  value: Pt.string.isRequired,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Form/LockingPasswordField.jsx